import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Lock body scroll while modal is open + close on Escape
  useEffect(() => {
    if (!isOpen) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = original;
      window.removeEventListener('keydown', handleKey);
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-375">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" aria-modal="true" role="dialog" data-id="element-376">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-charcoal/70 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-377" />

          {/* Modal panel */}
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-cream rounded-3xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col overflow-hidden" data-id="element-378">
            {/* Header */}
            <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-sage-100 sticky top-0 bg-cream z-10" data-id="element-379">
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-sage-800 pr-4" data-id="element-380">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="flex-shrink-0 w-9 h-9 rounded-full bg-sage-100 hover:bg-sage-200 text-sage-800 flex items-center justify-center transition-colors" data-id="element-381">
                <X size={18} data-id="element-382" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 md:px-8 py-6 text-charcoal-light leading-relaxed text-sm md:text-base space-y-4" data-id="element-383">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}